<aumico-notes-input-options
    [hideReference]="true"
    [options]="data.options"
    [languages]="data.languages"
    (onFormValueChange)="onFormChange($event)"
    (onFormStatusChange)="onFormStatusChange($event)"
></aumico-notes-input-options>

<div class="save-button">
    <button class="btn btn-success m-1" [disabled]="!isFormValid" (click)="onSaveButtonClick()">
        {{ 'aumico_button_save' | i18next }}
    </button>
</div>
